<template>
  <div class="SubspaceModal">
    <div class="SubspaceModal--icon" @click="closeDeleteModal">
      <IconClose />
    </div>
    <div>
      <div class="SubspaceModal--title">Are you sure you want to delete this subspace?</div>
      <div class="SubspaceModal--desc">
        Please note that any items within this subspace that also exist elsewhere will remain unaffected. However, items that are exclusive to this subspace will be moved to trash.
      </div>
    </div>
    <div @click="deleteSubspace" class="SubspaceModal--delete">Delete subspace</div>
  </div>
</template>

<script>
import SubspaceMethods from "./SubspaceMethods";
import IconClose from "../../ELYXIcons/IconClose.vue";

export default {
  components: {
    IconClose,
  },
  methods: {
    closeDeleteModal: SubspaceMethods.closeDeleteModal,
    deleteSubspace: SubspaceMethods.deleteSubspace,
  },
};
</script>

<style scoped>
.SubspaceModal {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 450px;
  height: unset;

  /** Applied so that upon clicking or double clicking surroundings, text isn't selected */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer and Edge */
  user-select: none; /* Standard CSS3 property */
}
.SubspaceModal--title {
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  line-height: 26px;
  margin-top: 10px;
  padding: 0px 4px;
}
.SubspaceModal--desc {
  margin-top: 10px;
  line-height: 22px;
  color: #222;
  font-size: 15px;
  padding: 0px 4px;
}
.SubspaceModal--delete {
  margin-top: 20px;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: #111;
  color: white;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: all 150ms cubic-bezier(0.55, 0.085, 0.68, 0.53) 0s;
}
.SubspaceModal--delete:hover {
  background-color: #555;
}
.SubspaceModal--icon {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  height: 30px;
  width: 30px;
  border-radius: 360px;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -10px;
}
.SubspaceModal--icon:hover {
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
}
</style>
